import { createHookContext } from '@clover-util/react-context';
import { useState } from 'react';
import { GiftCard } from 'olo-service/models';

export const { useGiftCard, GiftCardProvider } = createHookContext('GiftCard', () => {
  const [appliedGiftCards, setAppliedGiftCards] = useState<GiftCard[]>([]);

  const setGiftCard = (giftCard : GiftCard) => {
    setAppliedGiftCards([...appliedGiftCards, giftCard]);
  };

  const unSetGiftCard = (token: string) => {
    setAppliedGiftCards(appliedGiftCards.filter(card => card.token !== token));
  };

  const removeLastGiftCard = () => {
    setAppliedGiftCards(appliedGiftCards.slice(0,-1));
  };

  const clearGiftCard = () => {
    setAppliedGiftCards([]);
  };

  return {
    appliedGiftCards,
    setAppliedGiftCards,
    removeLastGiftCard,
    setGiftCard,
    clearGiftCard,
    unSetGiftCard
  };
});
